import React from 'react';
import { useParams } from 'react-router-dom';
import NewsArticleSection from '../components/sections/NewsArticleSection';
import ContactSection from '../components/sections/ContactSection';

const NewsArticlePage = () => {
  const { id } = useParams();
  
  // News data with full content for the first article
  const newsArticles = [
    {
      id: 1,
      title: "Mavis Tire Completes Acquisition of Midas from TBC Corporation",
      date: "Jun 16, 2025",
      category: "Acquisitions",
      source: "Business Wire",
      content: [
        "Transaction expands Mavis's retail footprint to more than 3,500 stores across the United States and Canada",
        "WHITE PLAINS, N.Y.--(BUSINESS WIRE)--Mavis Tire Express Services Corp. (Mavis), a leading provider of automotive repair and maintenance services and one of the largest independent tire and service providers in North America, announced today that it has completed the purchase of Midas from TBC Corporation (TBC). Financial terms of the transaction are not being disclosed.",
      ],
      excerpt: "WHITE PLAINS, N.Y.--(BUSINESS WIRE)--Mavis Tire Express Services Corp. (Mavis), a leading provider of automotive repair and maintenance services and one of the largest independent tire and service providers in North America."
    },
    {
      id: 2,
      title: "Harbor Receives Majority Investment from BayPine to Drive Digital Innovation Across Legal Sector",
      date: "Jun 04, 2025",
      excerpt: "CHICAGO, June 4, 2025 – Harbor Global, LLC (Harbor or the Company), the preeminent provider of consulting and technology services to the legal industry, today announced that it has received a majority investment from BayPine.",
      category: "Investments",
      source: "Business Wire",
      content: [
        "Renovus Continues as Significant Investor in Partnership with BayPine and Harbor Management",
        "CHICAGO, June 4, 2025 – Harbor Global, LLC (Harbor or the Company), the preeminent provider of consulting and technology services to the legal industry, today announced that it has received a majority investment from BayPine LP (BayPine), a private investment firm that drives digital transformation in market-leading businesses. Harbor's initial private equity sponsor Renovus Capital Partners (Renovus) will remain a significant investor in the Company, alongside the existing Harbor management team. Terms of the transaction were not disclosed."
      ]
    },
    {
      id: 3,
      title: "BayPine to Acquire CenExel",
      date: "Apr 14, 2025",
      excerpt: "BOSTON--(BUSINESS WIRE)--BayPine LP (BayPine), a private investment firm that drives digital transformation in market-leading businesses, today announced that it has entered into a definitive agreement to acquire CenExel Clinical Research.",
      category: "Acquisitions",
      source: "Business Wire",
      content: [
        "Business Wire",
        "14 April 2025",
        "BOSTON--(BUSINESS WIRE)--BayPine LP (BayPine), a private investment firm that drives digital transformation in market-leading businesses, today announced that it has entered into a definitive agreement to acquire CenExel Clinical Research, Inc. (CenExel or the Company), a leading clinical trial site network focused on complex therapeutic areas."
      ]
    },
    {
      id: 4,
      title: "What's All the Fuss About AI?",
      date: "Nov 21, 2024",
      excerpt: "Artificial intelligence has leapt into the public consciousness with a string of recent product announcements and relentless media coverage[1]. We have a slew of new launches from Nvidia, Alphabet (Google) & Meta (Facebook).",
      category: "Insights",
      source: "BayPine Insights",
      content: [
        "Artificial intelligence has leapt into the public consciousness with a string of recent product announcements and relentless media coverage[1]. We have a slew of new launches from Nvidia, Alphabet (Google), Meta (Facebook), Microsoft and Apple, plus many more initiatives from well-funded start-ups like Anthropic, Cohere, Inflection, Mistral, Perplexity, SSI and xAI. These companies' various demos, social media postings and advertisements have dominated the business news and helped to educate the public about a remarkable array of new AI capabilities."
      ]
    },
    {
      id: 5,
      title: "BayPine appoints Migo Terjanian as partner and head of investor relations",
      date: "May 14, 2024",
      excerpt: "BOSTON – MAY 14, 2024 - BayPine LP (BayPine), a private investment firm that drives digital transformation in market-leading businesses, today announced the appointment of Migo Terjanian as a Partner and Head of Investor Relations.",
      category: "Company News",
      source: "BayPine Press Release",
      content: [
        "BOSTON – MAY 14, 2024 - BayPine LP (BayPine), a private investment firm that drives digital transformation in market-leading businesses, today announced the appointment of Migo Terjanian as a Partner and Head of Investor Relations. In this role, Mr. Terjanian will lead the firm's fundraising efforts and deepen and expand BayPine's relationships with the global institutional investment community."
      ]
    },
    {
      id: 6,
      title: "Investor Group Led by Arsenal, in Partnership with BayPine, Acquires POLYWOOD",
      date: "Mar 25, 2024",
      excerpt: "March 25, 2024 – New York, Boston & Syracuse, Indiana – An investor group led by Arsenal Capital Partners (Arsenal), a private equity firm that specializes in building technology-rich, market leading industrial growth and healthcare companies.",
      category: "Partnerships",
      source: "Joint Press Release",
      content: [
        "March 25, 2024 – New York, Boston & Syracuse, Indiana – An investor group led by Arsenal Capital Partners (Arsenal), a private equity firm that specializes in building technology-rich, market leading industrial growth and healthcare companies, in partnership with BayPine LP (BayPine), a private investment firm that drives digital transformation in market-leading businesses"
      ]
    },
    {
      id: 7,
      title: "BayPine Strengthens Leadership Team With Senior Operating Talent",
      date: "Nov 14, 2023",
      excerpt: "BayPine LP (BayPine), a private investment firm that drives digital transformation in market-leading businesses, today announced that it has strengthened its leadership team with two senior appointments.",
      category: "Company News",
      source: "BayPine Press Release",
      content: [
        "BOSTON, November 14, 2023 – BayPine LP (BayPine), a private investment firm that drives digital transformation in market-leading businesses, today announced that it has strengthened its leadership team with two senior appointments. Cory A. Eaves, an accomplished operating executive and product and technology leader"
      ]
    },
    {
      id: 8,
      title: "Mavis Tire Express Services Corp. to Acquire NTB and Tire Kingdom Businesses from TBC Corporation",
      date: "May 23, 2023",
      excerpt: "Palm Beach Gardens, FL and Millwood, NY – (May 22, 2023) – TBC Corporation (TBC), one of North America's leading providers of mobility solutions, announced today that it has entered into an agreement to divest its company-owned.",
      category: "Acquisitions",
      source: "Business Wire",
      content: [
        "Palm Beach Gardens, FL and Millwood, NY – (May 22, 2023) – TBC Corporation (TBC), one of North America's leading providers of mobility solutions, announced today that it has entered into an agreement to divest its company-owned NTB Tire & Service Centers and Tire Kingdom retail businesses to Mavis Tire Express Services Corp. (Mavis), one of the largest independent tire and service providers in the United States.",
        "The transaction is expected to close mid-year 2023, subject to customary closing conditions and regulatory approvals. Financial terms of the transaction were not disclosed."
      ]
    },
    {
      id: 9,
      title: "Penn Foster Group Begins the Next Chapter of 130 Year History by Bringing Top Online Education and Career Training Brands Together Under a New Name",
      date: "Apr 17, 2023",
      excerpt: "SCRANTON, Pa, April 17, 2023 — Penn Foster, a leading provider of digital and data-driven learning solutions for high demand skills and jobs, has unveiled the new name that marks the next phase of its 130+ year history — Penn Foster Group.",
      category: "Portfolio News",
      source: "Penn Foster Group Press Release",
      content: [
        "SCRANTON, Pa, April 17, 2023 — Penn Foster, a leading provider of digital and data-driven learning solutions for high demand skills and jobs, has unveiled the new name that marks the next phase of its 130+ year history — Penn Foster Group.",
        "The new name reflects the company's evolution into a family of brands that includes Penn Foster, CareerStep, and Ashworth College, which together serve more than 300,000 actively enrolled learners each year in addition to working with hundreds of employer and institutional partners."
      ]
    },
    {
      id: 10,
      title: "BayPine Vice President Emily Osman Lawrie Named 2023 M&A Business Development Professional to Watch",
      date: "Feb 06, 2023",
      excerpt: "BayPine Vice President Emily Osman Lawrie was named a 2023 M&A Business Development Professional to Watch by Middle Market Growth, which recognized ten standout, up-and-coming professionals in each of the categories of private equity business development.",
      category: "Company News",
      source: "BayPine News",
      content: [
        "BayPine Vice President Emily Osman Lawrie was named a 2023 M&A Business Development Professional to Watch by Middle Market Growth, which recognized ten standout, up-and-coming professionals in each of the categories of private equity business development, investment banking business development, and corporate development.",
        "The publication noted that Emily has been instrumental in building BayPine's business development function, including establishing the firm's sourcing strategy, developing its CRM system, and creating a network of intermediaries."
      ]
    }
  ];
  
  // Find the article with the matching ID
  const articleId = parseInt(id, 10);
  const article = newsArticles.find(article => article.id === articleId);
  
  return (
    <>
      <NewsArticleSection article={article} />
      <ContactSection />
    </>
  );
};

export default NewsArticlePage;